import { useContext } from "react";
import { get } from "lodash";
import { ThemeContext } from "styled-components/native";
import { Theme } from "../types";

export const useColorTokens = (value?: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const useTheme = () => useContext(ThemeContext as any) as Theme;
  const { colorTokens } = useTheme();

  if (value) {
    const tokenValue = get(colorTokens, value);

    if (!tokenValue && process.env.NODE_ENV !== "production") {
      throw new Error(`Invalid color token: ${value}`);
    }

    return tokenValue;
  }

  return colorTokens;
};
